// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  --padding-start: 0px;
}

ion-datetime {
  max-width: 100%;
}

.border {
  --padding-start: 0px;
  border: 1px solid black;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/migration-transaction-history/migration-transaction-history.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAGA;EACI,oBAAA;EACA,uBAAA;AAAJ","sourcesContent":["ion-item {\r\n    --padding-start: 0px;\r\n}\r\n\r\nion-datetime {\r\n    max-width: 100%;\r\n}\r\n\r\n\r\n.border {\r\n    --padding-start: 0px;\r\n    border: 1px solid black;\r\n   \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
